export default __webpack_public_path__ + "static/media/react.fc850075.png";